import { render } from "./Index.vue?vue&type=template&id=dea7e0e0&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=dea7e0e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dea7e0e0"

export default script